import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";
import { DoorClosingScreen } from "~/components/DoorClosingScreen";
import { AppHeader } from "~/components/layout/AppHeader";

export const Route = createFileRoute("/one-delivery/collect")({
	beforeLoad: () => {
		document.title = "bacehub | One Delivery";
	},
	component: RouteComponent,
	validateSearch: zodValidator(z.object({ bundleId: z.string(), unlockRequestId: z.string() })),
});

function RouteComponent() {
	const navigate = useNavigate();
	const { bundleId, unlockRequestId } = Route.useSearch();
	return (
		<DoorClosingScreen
			unlockRequestId={unlockRequestId}
			header={<AppHeader showHelpButton={true} />}
			onExit={() => navigate({ to: "/one-delivery/bundle/$bundleId", params: { bundleId } })}
			onClosed={() => navigate({ from: Route.fullPath, to: "/one-delivery/finish", search: { bundleId } })}
		/>
	);
}
